export default "__VITE_IMAGE_ASSET__770bcbd9__";